import buildPropertyRatesKey from 'lib/offer/buildPropertyRatesKey'
import generateOccupancyStringByRoom from 'lib/offer/generateOccupancyStringByRoom'

interface PropertyRatesKeyParams {
  propertyId: string | undefined
  checkIn: string | undefined
  checkOut: string | undefined
  occupancies: Array<App.Occupants>
  utmContent: string | undefined
  roomTypeId: string | undefined
  roomRateId: string | undefined
}

export interface PropertyRatesReduxKeys {
  /** Redux key for the combined-view record, built from all requested occupancies. */
  combined: string
  /** Per-occupancy redux keys, keyed by the encoded occupancy slot (e.g. `'2'`, `'1-5,12'`). */
  byOccupancy: Record<string, string>
}

/** Returns `undefined` when params can't form a key. */
export default function getPropertyRatesReduxKeys(
  params: PropertyRatesKeyParams,
): PropertyRatesReduxKeys | undefined {
  const combined = buildPropertyRatesKey(params)
  if (!combined) return undefined
  const byOccupancy: Record<string, string> = {}
  // Accommodation service doesn't populate per-occupancy entries for single-room requests, so the
  // combined key already covers it — skip generating per-occupancy keys we'll never see in state.
  if (params.occupancies.length > 1) {
    for (const room of params.occupancies) {
      byOccupancy[generateOccupancyStringByRoom(room)] = buildPropertyRatesKey({
        ...params,
        occupancies: [room],
      })
    }
  }
  return { combined, byOccupancy }
}
